<template>
  <b-row class="block">
    <h3>Adicionar Postagem</h3>

    <b-row>
      <b-form inline>
        <label class="sr-only" for="nome-jogo">Nome do Jogo</label>
        <b-form-input
          id="nome-jogo"
          class="mb-4 mr-sm-4 mb-sm-0"
          placeholder="Nome do jogo"
          v-model="title"
        ></b-form-input>

        <label class="sr-only" for="inline-form-input-username">Equipe de Tradução</label>
        <b-input-group class="mb-4 mr-sm-4 mb-sm-0">
          <b-form-input
            id="inline-form-input-username"
            placeholder="Nome da Equipe"
            v-model="equipe"
          ></b-form-input>
        </b-input-group>

        <label class="sr-only" for="imagem">Url da Imagem</label>
        <b-form-input
          id="imagem"
          class="mb-4 mr-sm-4 mb-sm-0"
          placeholder="Url da imagem"
          v-model="img"
        ></b-form-input>

        <label class="sr-only" for="equipe">Contato da Equipe de Tradução</label>
        <b-form-input
          id="equipe"
          class="mb-4 mr-sm-4 mb-sm-0"
          placeholder="Site da equipe"
          v-model="creditos"
        ></b-form-input>

        <label class="sr-only" for="url-downlaod">URL do Download</label>
        <b-form-input
          id="url-downlaod"
          class="mb-4 mr-sm-4 mb-sm-0"
          placeholder="Url do Download"
          v-model="download"
        ></b-form-input>

        <b-button variant="primary" @click="createPostagem()">Enviar</b-button>
      </b-form>
    </b-row>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AdicionarPostagem",
  data() {
    return { 
      title: "", 
      equipe: "", 
      img: "", 
      creditos: "", 
      download: "",
      data: new Date()
      };
  },
  computed: mapGetters(["allPostagens"]),
  methods: {
    ...mapActions(["addPostagem"]),
    createPostagem(){
      let user = {
        "id": (this.allPostagens.length + 1),
        "title": this.title,
        "img": this.img,
        "equipe": this.equipe,
        "creditos": this.creditos,
        "download": this.download,
        "data": `${this.data.getDate()}/${this.data.getMonth()+1}/${this.data.getFullYear()}`
      }

      this.addPostagem(user)
      alert('Postagem adicionada com sucesso!')
    }
  },
};
</script>

<style>
.block {
  display: block;
}

.bkg{
  background-color: white;
  justify-content: center;
  border-radius:  15px;
}
</style>